module.exports = require("lodash-es/intersection");